import { z } from 'zod';
import { ExamKey, TableColumn, TopicPath, WebUrl } from './fields.js';
/** Real SSC previous-year questions (ADR 0041). Everything here needs the `pyq_bank` flag. */
export const PyqRefDto = z
    .object({
    examKey: ExamKey,
    examName: z.string().trim().min(1).max(80),
    year: z.number().int().min(1990).max(2100),
    shift: z.string().trim().max(40).optional(),
    stage: z.string().trim().max(40).optional(),
    paper: z.string().trim().max(40).optional(),
    examDate: z.iso.date().optional(),
    officialUrl: WebUrl.optional(),
    answerKey: z.enum(['final', 'tentative']).optional(),
})
    .strict();
export const PyqFromSourceRequest = z
    .object({
    sourceId: z.uuid(),
    ref: PyqRefDto,
    answerKeyText: z.string().max(200_000).optional(),
    answerSourceId: z.uuid().optional(),
    topicPath: TopicPath.optional(),
})
    .strict();
export const PyqTableMeta = z
    .object({
    mapping: z
        .object({
        stem: TableColumn,
        options: z.tuple([TableColumn, TableColumn, TableColumn, TableColumn]),
        answer: TableColumn,
        questionNo: TableColumn.optional(),
        topicPath: TableColumn.optional(),
    })
        .strict(),
    ref: PyqRefDto,
})
    .strict();
export const PyqRowPatchRequest = z
    .object({
    stem: z.string().trim().max(2000).optional(),
    options: z.array(z.string().trim().max(500)).length(4).optional(),
    correctIndex: z.number().int().min(0).max(3).nullable().optional(),
    topicPath: TopicPath.nullable().optional(),
    hasFigure: z.boolean().optional(),
    questionNo: z.number().int().min(1).max(999).optional(),
})
    .strict();
export const PyqApproveRequest = z
    .object({ repeatOf: z.uuid().optional(), keepBoth: z.boolean().optional() })
    .strict();
export const PyqRowState = z.enum(['pending', 'approved', 'skipped']);
export const PyqRowDto = z.object({
    id: z.uuid(),
    batchId: z.uuid(),
    sourceId: z.uuid().nullable(),
    rowNo: z.number(),
    questionNo: z.number().nullable(),
    stem: z.string(),
    options: z.array(z.string()),
    correctIndex: z.number().nullable(),
    topicPath: z.string().nullable(),
    page: z.number().nullable(),
    confidence: z.number(),
    hasFigure: z.boolean(),
    ref: PyqRefDto,
    issues: z.array(z.string()),
    state: PyqRowState,
    itemId: z.uuid().nullable(),
});
export const PyqBatchSummaryDto = z.object({
    batchId: z.uuid(),
    pending: z.number(),
    approved: z.number(),
    skipped: z.number(),
});
export const PyqBatchDto = z.object({
    batchId: z.uuid(),
    ref: PyqRefDto,
    total: z.number(),
    pending: z.number(),
    createdAt: z.string(),
});
export const PyqRowsQuery = z.object({ state: PyqRowState.optional() }).strict();
//# sourceMappingURL=pyq.js.map